
import axios from 'axios';


const api = axios.create({
  // Uncomment the appropriate base URL for your needs
  // baseURL: 'http://localhost:8000',
  // baseURL: 'http://3.23.89.171:8000',
  // baseURL: 'http://18.191.219.237:8000',
  baseURL: 'https://www.freshsweeper.com',
  headers: {
    'Content-type': 'application/json',
  },
});



export default api;
